import { clubbiStyled } from 'clubbi-ui'

export const StyledLink = clubbiStyled('div')<{ disabled: boolean }>(({ disabled, theme }) => ({
  color: disabled ? theme.palette.brandGrey.main : theme.palette.brandPurple.main,
  fontWeight: 700,
}))
